export const setOrganizationAttributes = (organization?: any, organizationId?: string) => {
  const emailPreference = organization?.emailPreference
  const brandId = organization?.brand?.data?.id

  if (window.Sprig) {
    // Only set attributes that have defined values
    if (emailPreference) {
      window.Sprig('setAttribute', 'emailPreference', emailPreference)
    }

    if (organizationId) {
      window.Sprig('setAttribute', 'organizationId', organizationId)
    }

    if (brandId) {
      window.Sprig('setAttribute', 'brandId', brandId)
    }
  }
}
